import React, {useCallback} from 'react'
import {Lang} from 'yougile-lang'
import {OptionsItemCheckbox} from '@components/common/base/dropdown-button-menu/types'
import {Icon} from '@components/common/base/icon'
import {SelectWithCheckboxes} from '@components/common/base/select-with-dropdown/select-with-checkboxes'
import {
  FilterCategory,
  useSearchStore
} from '@components/right-panel/search/search-store'

const useCategoryOptions = () => {
  const [state] = useSearchStore()

  const res: OptionsItemCheckbox[] = [
    {
      key: 'task-title',
      text: Lang.msg.globalSearch.category.taskTitle,
      icon: 'IconCustomTaskDoneEmpty'
    },
    {
      key: 'user-name',
      text: Lang.msg.globalSearch.category.userName,
      icon: 'IconUsers'
    },
    {
      key: 'group-chat-title',
      text: Lang.msg.globalSearch.category.groupChatTitle,
      icon: 'IconMessage'
    },
    {
      key: 'message',
      text: Lang.msg.globalSearch.category.message,
      icon: 'IconMessages'
    },
    {
      key: 'description',
      text: Lang.msg.globalSearch.category.description,
      icon: 'IconFileDescription'
    },
    {
      key: 'checklist',
      text: Lang.msg.globalSearch.category.checklist,
      icon: 'IconCheckbox'
    }
  ]

  const selected = new Set(state.filterState.categories)
  for (const x of res) {
    x.selected = selected.has(x.key as FilterCategory)
  }
  return res
}

const useCategoryOptionsValue = () =>
  useCallback((options: OptionsItemCheckbox[]) => {
    let selected = 0
    options.forEach(x => (selected += Number(x.selected)))
    if (!selected || selected === options.length) {
      // All selected&none selected is the same state
      return Lang.msg.globalSearch.categoryAllCaption
    }

    const value: React.ReactNode[] = []
    options
      .filter(x => x.selected)
      .forEach((x, ix) => {
        ix &&
          value.push(
            <React.Fragment key={`${x.key}-comma`}>,&nbsp;</React.Fragment>
          )
        x.icon && value.push(<Icon key={x.key} icon={x.icon} />)
      })
    return <div className="flex overflow-hidden">{value}</div>
  }, [])

export const CategorySelect = () => {
  const [, store] = useSearchStore()

  const options = useCategoryOptions()
  const value = useCategoryOptionsValue()

  return (
    <SelectWithCheckboxes
      allCaption={Lang.msg.globalSearch.categoryAllCaption}
      variant="new"
      innerClassName="w-[244px]"
      options={options}
      value={value}
      onChange={store.onChangeFilterCategories}
    />
  )
}
